/**
 * @generated SignedSource<<b80130eba5c894de1e13cd5c6804ce23>>
 * @relayHash 94171d73f0b272e1bf79f834644e30ee
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cd7fc873151d4d24401d533da4e765943aac7ad30889166d1d08b1de14326d9

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignUpUserMutationInput = {
  authRedirectPath?: string | null | undefined;
  email: string;
  firstName: string;
  lastName: string;
  slugId?: string | null | undefined;
};
export type SignUpScreenContentSignUpMutation$variables = {
  input: SignUpUserMutationInput;
};
export type SignUpScreenContentSignUpMutation$data = {
  readonly signUpUser: {
    readonly __typename: string;
  };
};
export type SignUpScreenContentSignUpMutation = {
  response: SignUpScreenContentSignUpMutation$data;
  variables: SignUpScreenContentSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "signUpUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpScreenContentSignUpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignUpScreenContentSignUpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9cd7fc873151d4d24401d533da4e765943aac7ad30889166d1d08b1de14326d9",
    "metadata": {},
    "name": "SignUpScreenContentSignUpMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "173ef4e97b5091cd3f6e09e5ee280b9f";

export default node;
